import request from '@/scripts/request';

export enum ActiveCallResCode {
  SUCCESS = 1,
  NOT_FOUND,
  FAIL,
}

export const mediaApis = {
  activeCall(params: { room_id: string }) {
    return request('/api/v1/chat/media/call/reset', {
      method: 'POST',
      data: params,
    });
  },
};
